module.exports = __webpack_public_path__ + "img/logo.518108ed.png";